/*
 * Quick Order (Gunner 2026-10-06): a part-number order form. Each line looks its part number up in the store's
 * product list (templates/collection.quick-order-data.liquid, fetched page by page), shows the item, prices it with
 * its price breaks, and "Add all to cart" puts every line in the cart at once. Part numbers match loosely: case,
 * spaces, dashes and slashes don't matter (B12/13-NON = b12-13 non). Typing shows matching parts to pick from.
 * Lines that can't be sold online (call to order, out of stock, discontinued) say so and stay out of the cart.
 * The list on the form is kept in this browser (localStorage) so a reload doesn't lose it.
 */
(function () {
  var root = document.querySelector("[data-qo]");
  if (!root) return;
  var PHONE = "480-820-9517", MAX_QTY = 9999, START_ROWS = 5, KEEP = "wccd-quick-order";
  var rowsEl = root.querySelector("[data-qo-rows]");
  var addBtn = root.querySelector("[data-qo-add]");
  var msgEl = root.querySelector("[data-qo-msg]");
  var items = [], byKey = {}, ready = false;

  var key = function (s) { return String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); };
  var money = function (n) { return "$" + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  // a choice sold with a minimum ("Single (min. 6)", "10 ft min."), the same rule as the product page
  var minFor = function (it) {
    var t = (it.option || "") + " " + (it.note || "");
    var m = t.match(/\(min\.?\s*(\d+)/i) || t.match(/minimum\s*(\d+)/i) || t.match(/(\d+)\s*ft\.?\s*min/i);
    return m ? Number(m[1]) : 1;
  };
  // price at a quantity: the last price break reached (tiers = [[qty, price], ...], first row = regular price)
  var unitPrice = function (it, q) {
    var p = it.price / 100;
    (it.tiers || []).forEach(function (t, i) { if (i > 0 && q >= t[0]) p = Number(t[1]); });
    return p;
  };
  var say = function (text, bad) {
    msgEl.textContent = text || ""; msgEl.hidden = !text; msgEl.classList.toggle("is-bad", !!bad);
  };

  // ---- the product list -------------------------------------------------------------------------------------------
  function load(page) {
    // no "Accept: application/json" header: Shopify answers a view= page asked for that way with a 404
    return fetch(root.getAttribute("data-feed") + "&page=" + page)
      .then(function (r) { if (!r.ok) throw new Error("feed"); return r.json(); })
      .then(function (d) {
        items = items.concat(d.items || []);
        return d.page < d.pages ? load(page + 1) : null;
      });
  }
  function index() {
    items.forEach(function (it) { (byKey[key(it.sku)] = byKey[key(it.sku)] || []).push(it); });
  }
  function matches(q) {
    var k = key(q), words = String(q).toLowerCase().split(/\s+/).filter(Boolean);
    if (!k) return [];
    var starts = [], has = [], named = [];
    items.forEach(function (it) {
      var s = key(it.sku), name = (it.name + " " + it.option).toLowerCase();
      if (s.indexOf(k) === 0) starts.push(it);
      else if (s.indexOf(k) > 0) has.push(it);
      else if (words.every(function (w) { return name.indexOf(w) !== -1; })) named.push(it);
    });
    return starts.concat(has, named).slice(0, 8);
  }

  // ---- rows -------------------------------------------------------------------------------------------------------
  function row(sku, qty) {
    var tr = document.createElement("tr");
    tr.className = "qo__row";
    tr.innerHTML =
      '<td class="qo__c-sku"><div class="qo__find"><input type="text" class="qo__sku" aria-label="Part number" autocomplete="off" spellcheck="false" placeholder="Part #">' +
      '<ul class="qo__suggest" role="listbox" hidden></ul></div></td>' +
      '<td class="qo__c-item"><span class="qo__item"></span></td>' +
      '<td class="qo__c-qty"><input type="number" class="qo__qty" aria-label="Quantity" min="1" max="' + MAX_QTY + '" step="1" inputmode="numeric"></td>' +
      '<td class="qo__c-price qo__each"></td><td class="qo__c-total qo__line"></td>' +
      '<td class="qo__c-x"><button type="button" class="qo__x" aria-label="Remove this line">×</button></td>';
    rowsEl.appendChild(tr);
    var skuIn = tr.querySelector(".qo__sku"), qtyIn = tr.querySelector(".qo__qty");
    if (sku) skuIn.value = sku;
    if (qty) qtyIn.value = qty;
    wire(tr);
    if (sku) resolve(tr, true);
    return tr;
  }
  function emptyRow() {
    var all = rowsEl.querySelectorAll(".qo__row");
    for (var i = 0; i < all.length; i++) if (!all[i].querySelector(".qo__sku").value.trim()) return all[i];
    return row();
  }
  function setItem(tr, it) {
    tr._it = it;
    var skuIn = tr.querySelector(".qo__sku"), qtyIn = tr.querySelector(".qo__qty");
    if (it) {
      skuIn.value = it.sku;
      var min = minFor(it);
      qtyIn.min = min;
      if (!qtyIn.value || Number(qtyIn.value) < min) qtyIn.value = min;
    } else {
      qtyIn.min = 1;
    }
    paint(tr);
  }
  // look the typed part number up: an exact (loose) match fills the line, else the line says what's wrong
  function resolve(tr, quiet) {
    var v = tr.querySelector(".qo__sku").value.trim();
    tr._miss = false;
    if (!v) { setItem(tr, null); return; }
    if (!ready) return;                         // checked again once the list has loaded
    var hit = byKey[key(v)];
    if (hit && hit.length === 1) { setItem(tr, hit[0]); return; }
    tr._miss = !hit;
    setItem(tr, null);
    if (!hit && !quiet) open(tr);
  }
  function paint(tr) {
    var it = tr._it, item = tr.querySelector(".qo__item"), each = tr.querySelector(".qo__each"), line = tr.querySelector(".qo__line");
    var q = Math.floor(Number(tr.querySelector(".qo__qty").value)) || 0;
    tr.classList.remove("is-bad", "is-call");
    if (!it) {
      var typed = tr.querySelector(".qo__sku").value.trim();
      item.innerHTML = typed && ready && tr._miss ? '<span class="qo__warn">Part number not found. Pick from the list, or call ' + PHONE + ".</span>" : "";
      if (typed && ready && tr._miss) tr.classList.add("is-bad");
      each.textContent = ""; line.textContent = "";
      return total();
    }
    var label = '<a href="' + esc(it.url) + '" target="_blank" rel="noopener">' + esc(it.name) + "</a>" +
      (it.option ? ' <span class="qo__opt">' + esc(it.option) + "</span>" : "");
    var why = it.state === "call_only" ? "Call to order: " + PHONE
      : it.state === "discontinued" ? "Discontinued"
      : it.state === "out_of_stock" || !it.available ? "Out of stock" : "";
    if (why) {
      tr.classList.add("is-call");
      item.innerHTML = label + '<span class="qo__warn">' + why + "</span>";
      each.textContent = it.price > 0 ? money(it.price / 100) : ""; line.textContent = "";
      return total();
    }
    var min = minFor(it);
    item.innerHTML = label + (min > 1 ? '<span class="qo__min">Minimum ' + min + "</span>" : "");
    var p = unitPrice(it, q);
    each.innerHTML = money(p) + (p < it.price / 100 ? ' <s class="qo__was">' + money(it.price / 100) + "</s>" : "");
    line.textContent = q > 0 ? money(p * q) : "";
    total();
  }
  function lines() {
    var out = [];
    rowsEl.querySelectorAll(".qo__row").forEach(function (tr) {
      var it = tr._it, q = Math.floor(Number(tr.querySelector(".qo__qty").value)) || 0;
      if (it && q > 0 && it.state === "buyable" && it.available) out.push({ tr: tr, it: it, q: q });
    });
    return out;
  }
  function total() {
    var sum = 0, ls = lines();
    ls.forEach(function (l) { sum += unitPrice(l.it, l.q) * l.q; });
    root.querySelector("[data-qo-total]").textContent = money(sum);
    addBtn.disabled = !ls.length;
    keep();
  }
  function keep() {
    var list = [];
    rowsEl.querySelectorAll(".qo__row").forEach(function (tr) {
      var s = tr.querySelector(".qo__sku").value.trim();
      if (s) list.push([s, tr.querySelector(".qo__qty").value]);
    });
    try { localStorage.setItem(KEEP, JSON.stringify(list)); } catch (e) { /* private window: not kept */ }
  }

  // ---- the part-number box: suggestions as you type ---------------------------------------------------------------
  function open(tr) {
    var box = tr.querySelector(".qo__suggest"), v = tr.querySelector(".qo__sku").value.trim();
    var found = ready && v ? matches(v) : [];
    if (!found.length) { box.hidden = true; return; }
    box.innerHTML = found.map(function (it, i) {
      return '<li role="option" data-i="' + i + '"' + (i === 0 ? ' class="is-on"' : "") + ">" +
        (it.img ? '<img src="' + esc(it.img) + '" alt="" width="36" height="36" loading="lazy">' : '<span class="qo__noimg"></span>') +
        '<span><strong>' + esc(it.sku) + "</strong> " + esc(it.name) + (it.option ? " · " + esc(it.option) : "") + "</span></li>";
    }).join("");
    box._found = found;
    box.hidden = false;
  }
  function pick(tr, it) {
    tr.querySelector(".qo__suggest").hidden = true;
    tr._miss = false;
    setItem(tr, it);
    tr.querySelector(".qo__qty").focus();
    tr.querySelector(".qo__qty").select();
  }
  function wire(tr) {
    var skuIn = tr.querySelector(".qo__sku"), qtyIn = tr.querySelector(".qo__qty"), box = tr.querySelector(".qo__suggest");
    skuIn.addEventListener("input", function () { tr._it = null; tr._miss = false; paint(tr); open(tr); });
    skuIn.addEventListener("keydown", function (e) {
      var on = box.querySelector(".is-on"), all = box.querySelectorAll("li");
      if (!box.hidden && (e.key === "ArrowDown" || e.key === "ArrowUp") && all.length) {
        e.preventDefault();
        var i = on ? Number(on.getAttribute("data-i")) : -1;
        i = (i + (e.key === "ArrowDown" ? 1 : all.length - 1)) % all.length;
        all.forEach(function (li) { li.classList.toggle("is-on", Number(li.getAttribute("data-i")) === i); });
      } else if (e.key === "Enter") {
        e.preventDefault();
        var hit = byKey[key(skuIn.value)];
        if (hit && hit.length === 1) pick(tr, hit[0]);
        else if (!box.hidden && on) pick(tr, box._found[Number(on.getAttribute("data-i"))]);
        else resolve(tr);
      } else if (e.key === "Escape") { box.hidden = true; }
    });
    skuIn.addEventListener("blur", function () { setTimeout(function () { box.hidden = true; if (!tr._it) resolve(tr, true); paint(tr); }, 150); });
    box.addEventListener("mousedown", function (e) {
      var li = e.target.closest("li");
      if (li) { e.preventDefault(); pick(tr, box._found[Number(li.getAttribute("data-i"))]); }
    });
    qtyIn.addEventListener("input", function () { paint(tr); });
    qtyIn.addEventListener("change", function () {
      var it = tr._it, q = Math.floor(Number(qtyIn.value)) || 0, min = it ? minFor(it) : 1;
      if (q > MAX_QTY) qtyIn.value = MAX_QTY;
      else if (q && q < min) { qtyIn.value = min; say("Part " + it.sku + " is sold in a minimum of " + min + ", so that line is now " + min + "."); }
      paint(tr);
    });
    qtyIn.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      e.preventDefault();
      var next = tr.nextElementSibling || row();
      next.querySelector(".qo__sku").focus();
    });
    tr.querySelector(".qo__x").addEventListener("click", function () {
      tr.remove();
      if (!rowsEl.querySelector(".qo__row")) row();
      total();
    });
  }

  // ---- paste a list -----------------------------------------------------------------------------------------------
  function addList(list) {
    var missing = [];
    list.forEach(function (l) {
      var tr = emptyRow();
      tr.querySelector(".qo__sku").value = l.sku;
      tr.querySelector(".qo__qty").value = l.qty || "";
      resolve(tr, true);
      if (!tr._it) missing.push(l.sku);
    });
    if (missing.length) say(missing.length + (missing.length === 1 ? " part number wasn't" : " part numbers weren't") + " found: " + missing.join(", ") + ". Fix them on the form, or call " + PHONE + ".", true);
    else say("");
  }
  root.querySelector("[data-qo-paste-go]").addEventListener("click", function () {
    var box = root.querySelector("[data-qo-paste]"), list = [];
    box.value.split(/\r?\n/).forEach(function (line) {
      var parts = line.trim().split(/[\t,;]+|\s+/).filter(Boolean);
      if (!parts.length) return;
      var q = "", sku;
      if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) { q = parts.pop(); }
      else if (parts.length > 1 && /^\d+$/.test(parts[0])) { q = parts.shift(); }
      sku = parts.join(" ");
      if (sku) list.push({ sku: sku, qty: q });
    });
    if (!list.length) return;
    addList(list);
    box.value = "";
  });

  // ---- order again (signed in) ------------------------------------------------------------------------------------
  var againData = root.querySelector("[data-qo-again]");
  if (againData) {
    var again = [];
    try { again = JSON.parse(againData.textContent); } catch (e) { again = []; }
    var ul = root.querySelector("[data-qo-again-list]");
    ul.innerHTML = again.map(function (a, i) {
      return '<li><button type="button" data-qo-again-i="' + i + '"><strong>' + esc(a.sku) + "</strong> " + esc(a.title) +
        '<span class="qo__again-last">Last: ' + a.qty + " on " + esc(a.date) + "</span></button></li>";
    }).join("");
    ul.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qo-again-i]");
      if (b) addList([{ sku: again[Number(b.getAttribute("data-qo-again-i"))].sku, qty: again[Number(b.getAttribute("data-qo-again-i"))].qty }]);
    });
    root.querySelector("[data-qo-again-all]").addEventListener("click", function () {
      addList(again.map(function (a) { return { sku: a.sku, qty: a.qty }; }));
    });
  }

  // ---- add all to cart --------------------------------------------------------------------------------------------
  var barTimer;
  function addedBar(lines) {
    var bar = document.querySelector(".fc-added");
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "fc-added";
      bar.setAttribute("role", "status");
      bar.innerHTML = '<span class="fc-added__msg"></span><a class="fc-added__cart" href="/cart">View cart</a>' +
        '<button type="button" class="fc-added__close" aria-label="Close">×</button>';
      bar.querySelector(".fc-added__close").addEventListener("click", function () { bar.classList.remove("is-open"); });
      document.body.appendChild(bar);
    }
    // counts the parts added, not the units (500 buttons is one part)
    bar.querySelector(".fc-added__msg").textContent = "✓ " + lines + (lines === 1 ? " part" : " parts") + " added to your cart";
    bar.classList.add("is-open");
    clearTimeout(barTimer);
    barTimer = setTimeout(function () { bar.classList.remove("is-open"); }, 3000);
  }
  addBtn.addEventListener("click", function () {
    var ls = lines();
    if (!ls.length) return;
    var label = addBtn.textContent;
    addBtn.disabled = true; addBtn.textContent = "Adding…"; say("");
    // the cart's per-item cap: what's already in the cart counts too (same as the product page)
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var have = {};
      (cart.items || []).forEach(function (i) { have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
      var want = {};
      ls.forEach(function (l) { want[l.it.id] = (want[l.it.id] || 0) + l.q; });
      var over = ls.filter(function (l) { return (have[l.it.id] || 0) + want[l.it.id] > MAX_QTY; });
      if (over.length) throw new Error("The most per item is " + MAX_QTY.toLocaleString() + " (counting what's already in your cart): " +
        over.map(function (l) { return l.it.sku; }).join(", ") + ". For a larger order, call " + PHONE + ".");
      return fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: ls.map(function (l) { return { id: l.it.id, quantity: l.q }; }) })
      });
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || "Those items couldn't be added. Call " + PHONE + ".");
        return fetch("/cart.js").then(function (x) { return x.json(); });
      });
    }).then(function (cart) {
      var count = document.querySelector("[data-cart-count]");
      if (count) count.textContent = cart.item_count;
      addBtn.textContent = "✓ Added to cart";
      addBtn.classList.add("is-added");
      addedBar(ls.length);
      // the lines that went in the cart come off the form; anything not added (not found, call to order) stays to fix
      ls.forEach(function (l) { l.tr.remove(); });
      rowsEl.querySelectorAll(".qo__row").forEach(function (tr) { if (!tr.querySelector(".qo__sku").value.trim()) tr.remove(); });
      for (var i = rowsEl.querySelectorAll(".qo__row").length; i < START_ROWS; i++) row();
      total();
      setTimeout(function () { addBtn.textContent = label; addBtn.classList.remove("is-added"); total(); }, 2000);
    }).catch(function (err) {
      addBtn.textContent = label; addBtn.disabled = false;
      say(err.message, true);
    });
  });

  // ---- save as a list: the parts on the form (found ones) go to Saved Lists, which asks which list ---------------
  var saveLink = root.querySelector("[data-qo-savelist]");
  if (saveLink) saveLink.addEventListener("click", function (e) {
    var picked = [];
    rowsEl.querySelectorAll(".qo__row").forEach(function (tr) {
      if (tr._it) picked.push(tr._it.sku + ":" + (Math.floor(Number(tr.querySelector(".qo__qty").value)) || 1));
    });
    e.preventDefault();
    if (!picked.length) { say("Put some parts on the form first, then save them as a list.", true); return; }
    window.location.href = saveLink.getAttribute("href") + "?add=" + encodeURIComponent(picked.join(","));
  });

  // ---- start ------------------------------------------------------------------------------------------------------
  root.querySelector("[data-qo-more]").addEventListener("click", function () { for (var i = 0; i < 5; i++) row(); });
  root.querySelector("[data-qo-clear]").addEventListener("click", function () {
    rowsEl.innerHTML = ""; for (var i = 0; i < START_ROWS; i++) row(); say(""); total();
  });
  var kept = [];
  try { kept = JSON.parse(localStorage.getItem(KEEP) || "[]"); } catch (e) { kept = []; }
  kept.forEach(function (k) { row(k[0], k[1]); });
  for (var i = kept.length; i < START_ROWS; i++) row();
  // ?sku=ME-12030:10,CVC40:2 fills the form (a link from an email or a saved list)
  var q = new URLSearchParams(window.location.search).get("sku");

  load(1).then(function () {
    ready = true;
    index();
    root.querySelector("[data-qo-loading]").hidden = true;
    rowsEl.querySelectorAll(".qo__row").forEach(function (tr) { if (tr.querySelector(".qo__sku").value.trim()) resolve(tr, true); });
    if (q) addList(q.split(",").map(function (p) { var s = p.split(":"); return { sku: s[0], qty: s[1] || "" }; }));
  }).catch(function () {
    root.querySelector("[data-qo-loading]").textContent = "The parts list didn't load. Reload the page, or call " + PHONE + ".";
  });
})();
